import { IDatastore, IObserver, IMapData, IGridCells, INodesList } from "./interface";
import { AtlasPopup } from "./atlas-popup";

export class Datastore implements IDatastore<IMapData, IGridCells> {
  private observers: IObserver<IMapData>[] = [];
  public gridcells: IGridCells;
  private data: INodesList;
  private associations: IMapData;
  public Popup: AtlasPopup;

  public RemoveObserver(Observer: IObserver<IMapData>) {
    this.observers = this.observers.filter(observer => observer !== Observer);
  }

  public RegisterObserver(Observer: IObserver<IMapData>) {
    this.observers.push(Observer);
  }

  public NotifyObservers() {
    this.observers.map((observer: IObserver<any>) => {
      if (typeof observer !== "undefined") {
        observer.ReceiveUpdate(this.data, this.associations);
      }
    });
  }

  public UpdateCells(Data: IGridCells) {
    this.gridcells = Data;
    this.NotifyObservers();
  }

  public UpdateData(Data: INodesList) {
    this.data = Data;
    this.NotifyObservers();
  }

  public UpdateAssociations(Data: IMapData) {
    this.associations = Data;
    this.NotifyObservers();
  }
}
